import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import apiClient from "../apiClient";
import PageContext from "../PageContext.jsx";

const LoansUpdate = () => {
  const [loan, setLoan] = useState({
    Description: "",
    LenderName: "",
    LoanDate: "",
  });
  const [error, setError] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const loanId = location.pathname.split("/")[2];

  useEffect(() => {
    const fetchLoan = async () => {
      try {
        const res = await apiClient.get("/loans");
        const rows = Array.isArray(res.data) ? res.data : [];
        const current = rows.find((row) => String(row.LoanID) === String(loanId));
        if (!current) {
          setError(true);
          return;
        }
        setLoan({
          Description: current.Description || "",
          LenderName: current.LenderName || "",
          LoanDate: current.LoanDate || "",
        });
      } catch (err) {
        setError(true);
      }
    };

    fetchLoan();
  }, [loanId]);

  const handleChange = (event) => {
    setLoan((current) => ({ ...current, [event.target.name]: event.target.value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!loan.Description?.trim() || !loan.LenderName?.trim() || !loan.LoanDate) {
      setError(true);
      return;
    }

    try {
      await apiClient.put(`/loans/${loanId}`, loan);
      navigate("/Loans");
    } catch (err) {
      setError(true);
    }
  };

  return (
    <div className="page">
      <header className="page-header">
        <div>
          <h1 className="page-title">Update Loan</h1>
          <p className="page-subtitle">
            <Link to="/">Home</Link> / <Link to="/Loans">Loans</Link> / Update
          </p>
        </div>
      </header>
      <PageContext
        items={[
          { label: "Home", to: "/" },
          { label: "Loans", to: "/Loans" },
          { label: "Update Loan" },
        ]}
        note={loan.Description ? `Editing ${loan.Description}.` : "Update the selected loan details."}
      />

      <section className="panel form-card">
        <form className="form" onSubmit={handleSubmit}>
          <label htmlFor="loan-description">Loan Name</label>
          <input
            id="loan-description"
            type="text"
            name="Description"
            value={loan.Description}
            onChange={handleChange}
            placeholder="e.g. Car Loan"
          />

          <label htmlFor="loan-lender">Lender</label>
          <input
            id="loan-lender"
            type="text"
            name="LenderName"
            value={loan.LenderName}
            onChange={handleChange}
            placeholder="e.g. Bank or individual lender"
          />

          <label htmlFor="loan-date">Loan Date</label>
          <input
            id="loan-date"
            type="date"
            name="LoanDate"
            value={loan.LoanDate}
            onChange={handleChange}
          />

          <div className="form-actions">
            <button className="btn" type="submit">Update Loan</button>
            <Link className="btn-link" to="/Loans">Cancel</Link>
          </div>
          {error && <p className="notice notice-error">Could not update loan. Check input and try again.</p>}
        </form>
      </section>
    </div>
  );
};

export default LoansUpdate;
